import React from 'react'
import "./style.css"

const Affiliates = () => {
  return (
    <div className='affiliate_container'>
      <h2>Affiliate Program </h2>

      <p>We welcome web as well as mobile apps developers to drive traffic to our website and start earning money through your traffic.</p>
      
      <h3>We Welcome</h3>
      <p>We have an extensive range of HTML5 games, optimized for both desktop and mobile devices. You can easily choose a few games or set up your own gaming portal as you wish. We are working hard to make sure all your demands are met – especially in terms of content and marketing. We strive to make sure our partners get the best possible results.</p>
      <p>Contact Us and Join Now</p>
      <p>
        <strong>Email:</strong>{" "}
        purusarthindustries@gmail.com
      </p>

      <h3>About Games</h3>
      <p> Our mission is simple - to create a browser-gaming platform that works seamlessly for users around the world, and rewards developers both big and small.</p>

      <p>Our games are playable on desktop, tablet, and mobile so you can enjoy them at school, at home, or on the road. Every month millions of gamers from all over the world play their favorite games on NajoxGames. Our goal is to create the ultimate online playground. Free and open to all.</p>

      <p>We're a team of makers, techies, adventurers – and some gamers too. We’re kids of all ages, and love what we do.</p>

      <p>Just load up your favorite games instantly in your web browser and enjoy the experience.</p>

      <p>You can play our games on desktop mobile devices. That includes everything from desktop PCs, laptops, and Chromebooks, to the latest smartphones and tablets from Apple and Android.</p>
    </div>
  )
}

export default Affiliates
